import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Label, Form, Alert, Input, FormFeedback } from 'reactstrap';
import logoDark from "../../assets/images/Aditya.png";
import logoLight from "../../assets/images/Aditya.png"; // Corrected logo import
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from '../../components/Common/withRouter'; // Corrected path to withRouter
import axios from "axios";

const Login = props => {
  document.title = "Login | TechnicalHub";
  const navigate = useNavigate();

  const [error, setError] = React.useState(null);
  const [Loading, setLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      roll_no: '',
      password: '',
    },
    validationSchema: Yup.object({
      roll_no: Yup.string().required("Please Enter Your user id"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => { // Made onSubmit function asynchronous
      try {
        setLoading(true)
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const response = await axios.post(backendUrl + "login", values, { withCredentials: true });
        if (response.status === 200) {
          localStorage.setItem('authUser', JSON.stringify(response.data))
          if (response.data.role === "developer" || response.data.role === "cashier" || response.data.role === "accounts") {
            navigate(`/dashboard`)
          }
          else if(response.data.role === "trainer" || response.data.role === "admin") {
            navigate(`/tech-panel-payments`)
          }
          else if (response.data.role === "superadmin") {
            navigate('/admin-dashboard')
          }
          else {
            navigate("/login");
            setError("Only authenticated roles only can access the Payment Portal");
          }
        }
      } catch (error) {
        console.error("Error:", error);
        setError("Invalid login credentials. Please try again.");
      } finally {
        setLoading(false)
      }
    }
  });

  const signIn = async (type) => {
    try {
      const response = await axios.post(`/social-login/${type}`);
      if (response.status === 200) {
        localStorage.setItem('authUser', JSON.stringify(response.data));
        navigate(`/dashboard`);
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Social login failed. Please try again.");
    }
  };

  const socialResponse = type => {
    signIn(type);
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">

                  <h3 className="text-center mt-5 mb-2">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="50" className="auth-logo-dark" />
                      <img src={logoLight} alt="" height="50" className="auth-logo-light" />
                    </Link>
                  </h3>

                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">Welcome Back !</h4>
                    <p className="text-muted text-center">Sign in to continue to Payment Portal.</p>
                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}
                      <div className="mb-3">
                        <Label htmlFor="username">User Id</Label>
                        <Input
                          name="roll_no"
                          className="form-control"
                          placeholder="Enter user Id"
                          type="text" // Changed type from "roll_no" to "text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.roll_no || ""}
                          invalid={
                            validation.touched.roll_no && validation.errors.roll_no ? true : false
                          }
                        />
                        {validation.touched.roll_no && validation.errors.roll_no ? (
                          <FormFeedback type="invalid">{validation.errors.roll_no}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="userpassword">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3 mt-4">
                        <div className="col-6">
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" id="customControlInline" />
                            <label className="form-check-label" htmlFor="customControlInline">Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={Loading}>
                            {
                              Loading ?
                                <div className='d-flex column-gap-1'>
                                  <div class="spinner-border spinner-border-sm" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                  <div>Loading...</div>
                                </div> :
                                "Log In"
                            }
                          </button>
                        </div>
                      </Row>
                      <Row className="form-group mb-0">
                        <Link to="/send-otp" className="text-muted"><i className="mdi mdi-lock"></i> Forgot your password?</Link>
                        {/* <Link to="/forgot-password" className="text-muted"><i className="mdi mdi-lock"></i> Forgot your password?</Link> */}
                        <div className="col-12 mt-4 d-flex justify-content-center">
                          {/* <Link
                            to="#"
                            className="social-list-item bg-danger text-white border-danger"
                            onClick={e => {
                              e.preventDefault();
                              socialResponse("google");
                            }}
                          >
                            <i className="mdi mdi-google" />
                          </Link> */}
                        </div>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                © {new Date().getFullYear()} Reserved to Technicalhub
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  )
}

export default withRouter(Login);

Login.propTypes = {
  router: PropTypes.object, // Changed prop name from 'history' to 'router'
};
